import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const MessageFrame = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Message Frame
      </Typography>
      <Paper elevation={2} sx={{ p: 2 }}>
        <Typography>
          This is the MessageFrame component. Replace this with your actual UI.
        </Typography>
      </Paper>
    </Box>
  );
};

export default MessageFrame;
